import { useAtom } from 'jotai'
import {
  timelineContainerRefAtom,
  timelineLeftScrollPositionAtom
} from '../atoms/timelineUi.atom'

export const useScrollTimeline = () => {
  const [timelineContainerRef] = useAtom(timelineContainerRefAtom)
  const [timelimeLeftScroll] = useAtom(timelineLeftScrollPositionAtom)

  return {
    timelineScrollPosition: timelimeLeftScroll,
    scrollTimeline: (args: {
      left?: number
      top?: number
    }) => {
      if (timelineContainerRef) {
        timelineContainerRef.scrollTo({
          ...args,
          behavior: 'smooth'
        })
      }
    }
  }
}
